module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12"
  }, [_c('div', {
    staticClass: "step-form__main"
  }, [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "brokerSubmitForm",
    staticClass: "step-form__form",
    attrs: {
      "model": _vm.brokerSubmitForm,
      "rules": _vm.rules
    }
  }, [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px",
      "margin-bottom": "30px"
    }
  }, [_vm._v("Business Information")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Company legal name *"
    },
    model: {
      value: (_vm.brokerSubmitForm.businessName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessName", $$v)
      },
      expression: "brokerSubmitForm.businessName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "tradeName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "DBA (If applicable)"
    },
    model: {
      value: (_vm.brokerSubmitForm.tradeName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "tradeName", $$v)
      },
      expression: "brokerSubmitForm.tradeName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "businessStreetAddress",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Address *",
      "maxlength": 40
    },
    model: {
      value: (_vm.brokerSubmitForm.businessStreetAddress),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessStreetAddress", $$v)
      },
      expression: "brokerSubmitForm.businessStreetAddress"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessCityName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "City *",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.businessCityName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessCityName", $$v)
      },
      expression: "brokerSubmitForm.businessCityName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "businessState",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state *"
    },
    model: {
      value: (_vm.brokerSubmitForm.businessState),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessState", $$v)
      },
      expression: "brokerSubmitForm.businessState"
    }
  }, _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "zip",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Zip *",
      "maxlength": 5
    },
    model: {
      value: (_vm.brokerSubmitForm.zip),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "zip", $$v)
      },
      expression: "brokerSubmitForm.zip"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "phone",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Company phone *",
      "maxlength": 10
    },
    model: {
      value: (_vm.brokerSubmitForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "phone", $$v)
      },
      expression: "brokerSubmitForm.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "companyEmail",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Company email *",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.companyEmail),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "companyEmail", $$v)
      },
      expression: "brokerSubmitForm.companyEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Website"
    },
    model: {
      value: (_vm.brokerSubmitForm.url),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "url", $$v)
      },
      expression: "brokerSubmitForm.url"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "stateOfInc",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state of incorporation *"
    },
    model: {
      value: (_vm.brokerSubmitForm.stateOfInc),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "stateOfInc", $$v)
      },
      expression: "brokerSubmitForm.stateOfInc"
    }
  }, _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "dateEstablished",
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "placeholder": "Date established *",
      "format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions1
    },
    model: {
      value: (_vm.brokerSubmitForm.dateEstablished),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "dateEstablished", $$v)
      },
      expression: "brokerSubmitForm.dateEstablished"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "prop": "tin",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "EIN (Tax ID number) *",
      "maxlength": 10
    },
    on: {
      "input": _vm.handleTinInput
    },
    model: {
      value: (_vm.brokerSubmitForm.tin),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "tin", $$v)
      },
      expression: "brokerSubmitForm.tin"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "industry",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select industry type *"
    },
    model: {
      value: (_vm.brokerSubmitForm.industry),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "industry", $$v)
      },
      expression: "brokerSubmitForm.industry"
    }
  }, _vm._l((_vm.industries), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "structure",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Company structure *"
    },
    model: {
      value: (_vm.brokerSubmitForm.structure),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "structure", $$v)
      },
      expression: "brokerSubmitForm.structure"
    }
  }, _vm._l((_vm.structures), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "revenue",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Annual revenue *",
      "maxlength": 16
    },
    model: {
      value: (_vm.brokerSubmitForm.revenue),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "revenue", $$v)
      },
      expression: "brokerSubmitForm.revenue"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "margin-bottom-0",
    attrs: {
      "label": "Business description",
      "prop": "description",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Please include details by describing your business, revenue stream, and specifics to the need for this loan. For Equipment Financing, please also add how this equipment loan will increase your revenue (i.e. debt service coverage ratio before and after loan) and what is the timing you will start to see a contribution to your revenue?",
      "rows": 3
    },
    model: {
      value: (_vm.brokerSubmitForm.description),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "description", $$v)
      },
      expression: "brokerSubmitForm.description"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px",
      "margin-bottom": "30px"
    }
  }, [_vm._v("Business Owners")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "First name *",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.firstName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "firstName", $$v)
      },
      expression: "brokerSubmitForm.firstName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 4,
      "lg": 4
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Middle name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.middleName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "middleName", $$v)
      },
      expression: "brokerSubmitForm.middleName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "lastName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Last name *",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.lastName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "lastName", $$v)
      },
      expression: "brokerSubmitForm.lastName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "ssn"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Social security number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 9
    },
    model: {
      value: (_vm.brokerSubmitForm.ssn),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "ssn", $$v)
      },
      expression: "brokerSubmitForm.ssn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "streetAddress",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Home address *",
      "maxlength": 40
    },
    model: {
      value: (_vm.brokerSubmitForm.streetAddress),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "streetAddress", $$v)
      },
      expression: "brokerSubmitForm.streetAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 4,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cityName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "City name *",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.cityName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "cityName", $$v)
      },
      expression: "brokerSubmitForm.cityName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 4,
      "lg": 4
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "state",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state *"
    },
    model: {
      value: (_vm.brokerSubmitForm.state),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "state", $$v)
      },
      expression: "brokerSubmitForm.state"
    }
  }, _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 4,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "zipCode",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Zip code *",
      "maxlength": 5
    },
    model: {
      value: (_vm.brokerSubmitForm.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "zipCode", $$v)
      },
      expression: "brokerSubmitForm.zipCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "dateOfBirth",
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "placeholder": "Date of birth *",
      "type": "date",
      "picker-options": _vm.pickerOptions1
    },
    on: {
      "change": _vm.getData
    },
    model: {
      value: (_vm.brokerSubmitForm.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "dateOfBirth", $$v)
      },
      expression: "brokerSubmitForm.dateOfBirth"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cellPhone",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "Phone *",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.brokerSubmitForm.cellPhone),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "cellPhone", $$v)
      },
      expression: "brokerSubmitForm.cellPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Email *",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.email),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "email", $$v)
      },
      expression: "brokerSubmitForm.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "jobTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Title (if applicable)",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.jobTitle),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "jobTitle", $$v)
      },
      expression: "brokerSubmitForm.jobTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessOwnership",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Business ownership % *",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.brokerSubmitForm.businessOwnership),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessOwnership", $$v)
      },
      expression: "brokerSubmitForm.businessOwnership"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px",
      "margin-bottom": "30px"
    },
    on: {
      "click": function($event) {
        _vm.showAddOwner = !_vm.showAddOwner
      }
    }
  }, [_vm._v("Add owner"), _c('i', {
    staticClass: "fa",
    class: {
      'fa-chevron-up': _vm.showAddOwner,
      'fa-chevron-down': !_vm.showAddOwner
    },
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddOwner),
      expression: "showAddOwner"
    }]
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "firstName2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "First name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.firstName2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "firstName2", $$v)
      },
      expression: "brokerSubmitForm.firstName2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 4,
      "lg": 4
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Middle name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.middleName2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "middleName2", $$v)
      },
      expression: "brokerSubmitForm.middleName2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "lastName2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Last name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.lastName2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "lastName2", $$v)
      },
      expression: "brokerSubmitForm.lastName2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "ssn2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Social security number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 9
    },
    model: {
      value: (_vm.brokerSubmitForm.ssn2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "ssn2", $$v)
      },
      expression: "brokerSubmitForm.ssn2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "streetAddress2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Home address",
      "maxlength": 40
    },
    model: {
      value: (_vm.brokerSubmitForm.streetAddress2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "streetAddress2", $$v)
      },
      expression: "brokerSubmitForm.streetAddress2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cityName2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "City name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.cityName2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "cityName2", $$v)
      },
      expression: "brokerSubmitForm.cityName2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "state2"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state"
    },
    model: {
      value: (_vm.brokerSubmitForm.state2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "state2", $$v)
      },
      expression: "brokerSubmitForm.state2"
    }
  }, _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "zipCode2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Zip code",
      "maxlength": 5
    },
    model: {
      value: (_vm.brokerSubmitForm.zipCode2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "zipCode2", $$v)
      },
      expression: "brokerSubmitForm.zipCode2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cellPhone2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "Phone",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 10
    },
    model: {
      value: (_vm.brokerSubmitForm.cellPhone2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "cellPhone2", $$v)
      },
      expression: "brokerSubmitForm.cellPhone2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "email2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Email",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.email2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "email2", $$v)
      },
      expression: "brokerSubmitForm.email2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "jobTitle2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Title (if applicable)",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.jobTitle2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "jobTitle2", $$v)
      },
      expression: "brokerSubmitForm.jobTitle2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessOwnership2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "Business ownership %",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "min": 0,
      "max": 100 - _vm.brokerSubmitForm.businessOwnership
    },
    model: {
      value: (_vm.brokerSubmitForm.businessOwnership2),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "businessOwnership2", $$v)
      },
      expression: "brokerSubmitForm.businessOwnership2"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px",
      "margin-bottom": "30px"
    }
  }, [_vm._v("Vendor (if applicable)")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "vendorName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Vendor name"
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorName", $$v)
      },
      expression: "brokerSubmitForm.vendorName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "vendorPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Company phone",
      "maxlength": 10
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorPhone),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorPhone", $$v)
      },
      expression: "brokerSubmitForm.vendorPhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "vendorAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 40,
      "placeholder": "Vendor address"
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorAddress),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorAddress", $$v)
      },
      expression: "brokerSubmitForm.vendorAddress"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "vendorCity",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 30,
      "placeholder": "City *"
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorCity),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorCity", $$v)
      },
      expression: "brokerSubmitForm.vendorCity"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "vendorState",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state *"
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorState),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorState", $$v)
      },
      expression: "brokerSubmitForm.vendorState"
    }
  }, _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "vendorZipCode",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Zip code *",
      "maxlength": 5
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorZipCode),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorZipCode", $$v)
      },
      expression: "brokerSubmitForm.vendorZipCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "Contact first name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Contact first name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorContactFirstName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorContactFirstName", $$v)
      },
      expression: "brokerSubmitForm.vendorContactFirstName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "Contact last name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Contact last name",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorContactLastName),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorContactLastName", $$v)
      },
      expression: "brokerSubmitForm.vendorContactLastName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "Contact email"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Contact email",
      "maxlength": 30
    },
    model: {
      value: (_vm.brokerSubmitForm.vendorContactEmail),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "vendorContactEmail", $$v)
      },
      expression: "brokerSubmitForm.vendorContactEmail"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Equipment amount",
      "prop": "equipmentAmount",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.brokerSubmitForm.equipmentAmount),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "equipmentAmount", $$v)
      },
      expression: "brokerSubmitForm.equipmentAmount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Equipment status",
      "prop": "equipmentStatus",
      "required": ""
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.brokerSubmitForm.equipmentStatus),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "equipmentStatus", $$v)
      },
      expression: "brokerSubmitForm.equipmentStatus"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Titled or Non-titled",
      "prop": "equipmentTitle",
      "required": ""
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.brokerSubmitForm.equipmentTitle),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "equipmentTitle", $$v)
      },
      expression: "brokerSubmitForm.equipmentTitle"
    }
  }, _vm._l((_vm.titled), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "amount",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "Loan amount *"
    },
    model: {
      value: (_vm.brokerSubmitForm.amount),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "amount", $$v)
      },
      expression: "brokerSubmitForm.amount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "term",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "select_width",
    attrs: {
      "placeholder": "Desired loan term *"
    },
    model: {
      value: (_vm.brokerSubmitForm.term),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "term", $$v)
      },
      expression: "brokerSubmitForm.term"
    }
  }, _vm._l((_vm.equipmentLoanTermS), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text.concat(' months'),
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "prop": "equipmentType",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Equipment Type *"
    },
    model: {
      value: (_vm.brokerSubmitForm.equipmentType),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "equipmentType", $$v)
      },
      expression: "brokerSubmitForm.equipmentType"
    }
  }, _vm._l((_vm.equipmentTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "margin-bottom-0",
    attrs: {
      "label": "Equipment description",
      "prop": "equipmentDesc",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.brokerSubmitForm.equipmentDesc),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "equipmentDesc", $$v)
      },
      expression: "brokerSubmitForm.equipmentDesc"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px",
      "margin-bottom": "30px"
    }
  }, [_vm._v("Documents")])]), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "14px",
      "line-height": "24px",
      "text-align": "left"
    }
  }, [_vm._v("Upload your business related documents. Must be PDF, JPEG, PNG or Excel. Individual files must be under 20 MB.")])]), _vm._v(" "), (!_vm.dialogVisible) ? _c('div', {
    staticStyle: {
      "height": "auto",
      "float": "left"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token,
        customerId: this.clientCustomerId
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen,
      "auto-upload": false,
      "on-change": _vm.submitUpload
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Add Attachment")])])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded"
    }
  }, [_c('a', {
    staticClass: "link preview_old",
    attrs: {
      "href": _vm.fileUrl1,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.fileName1))])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.uploadedDocuments,
      "align": "left"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "#"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "label": "File Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ext",
      "label": "File Type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Actions"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.reviewFile(scope.row.fileId)
            }
          }
        }, [_vm._v("Review")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteFile(scope.row.fileId)
            }
          }
        }, [_vm._v("Delete")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "margin-bottom-0",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Notes",
      "rows": 3
    },
    model: {
      value: (_vm.brokerSubmitForm.brokerNote),
      callback: function($$v) {
        _vm.$set(_vm.brokerSubmitForm, "brokerNote", $$v)
      },
      expression: "brokerSubmitForm.brokerNote"
    }
  })], 1)], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12"
  }, [_c('div', {
    staticClass: "step-form__main pt-3"
  }, [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    staticClass: "step-form__form"
  }, [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px",
      "margin-bottom": "20px"
    }
  }, [_vm._v("Declaration")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#33475b",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "400",
      "font-size": "14px",
      "line-height": "24px",
      "text-align": "left"
    }
  }, [_vm._v("\n                I hereby confirm that each Company Owner of the Company provided in this Application (i) is aware of the Company's request for financing; (ii) may be required to guaranty the requested financing; and (iii) have authorized American Credit, Inc and any assignee, lender, or funding service that may be used to obtain their respective business and consumer credit report and have authorized me to provide their consent (collectively theCredit Consent).\n                ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#33475b",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "400",
      "font-size": "14px",
      "line-height": "24px",
      "text-align": "left"
    }
  }, [_vm._v("\n                By clicking I agree below, I am authorized to, and hereby permit, American Credit, Inc and any assignee, lender, or funding service that may be used to obtain (i) a consumer credit report on each Company Owner for credit purposes & further authorize the release to American Credit, Inc and any assignee, lender, or funding service that may be used of all credit information it may request, including business & personal banking, mortgage, landlord, trade & lease information related to each of them; and (ii) confirm that each Company Owner of the company has provided the Credit Consent.\n                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-left": "5px"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "text-align": "left"
    },
    model: {
      value: (_vm.declarationAgree),
      callback: function($$v) {
        _vm.declarationAgree = $$v
      },
      expression: "declarationAgree"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "agree"
    }
  }, [_vm._v("I agree")])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_vm._v(">\n                      "), _c('el-radio', {
    attrs: {
      "label": "disagree"
    }
  }, [_vm._v("I disagree")])], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#33475b",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "400",
      "font-size": "14px",
      "line-height": "24px",
      "text-align": "left"
    }
  }, [_vm._v("I hereby confirm that by providing American Credit, Inc and any assignee, lender, or funding service that may be used with an email address or telephone number, including for a wireless device, I have obtained, and am authorized to provide, the necessary express consent from each Company Owner, and that by submitting this Application, I expressly consent on behalfof each Company Owner to communications including email, voice and text messages from, or on behalf of, American Credit, Inc and any assignee, lender, or funding service that may be used, regardless of their purpose, including but not limited to marketing or collection purposes. I understand and agree that: (i) these calls and messages may be subject to charges from an internet or wireless provider; (ii) this consent is not a condition of doing business with, or making a purchase of any goods/services from, American Credit, Inc and any assignee, lender, or funding service that may be used;and (iii) any Company Owner may unsubscribe or opt-out of any further telemarketing calls or marketing text messages at any time.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#33475b",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "400",
      "font-size": "14px",
      "line-height": "24px",
      "text-align": "left"
    }
  }, [_vm._v("By clicking submit, you hereby agree the information you provided as well asthe confirmations set forth in this Application are true and accurate.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#33475b",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "400",
      "font-size": "14px",
      "line-height": "24px",
      "text-align": "left"
    }
  }, [_vm._v("Thank you for your business credit application. We will review it carefully andget back to you promptly.")])], 1)], 1)], 1), _vm._v(" "), (_vm.frontApplyId == '') ? _c('div', {
    staticClass: "step-form__btn-container"
  }, [_c('el-button', {
    staticClass: "rounded-pill blue px-5",
    staticStyle: {
      "float": "center"
    },
    attrs: {
      "disabled": _vm.declarationAgree !== 'agree',
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitApplicationForm
    }
  }, [_vm._v("Submit")])], 1) : _vm._e(), _vm._v(" "), (_vm.frontApplyId != '') ? _c('div', {
    staticClass: "step-form__btn-container"
  }, [_c('el-button', {
    staticClass: "rounded-pill blue px-5",
    staticStyle: {
      "float": "center"
    },
    attrs: {
      "disabled": _vm.declarationAgree !== 'agree',
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitApplicationForm
    }
  }, [_vm._v("Save")])], 1) : _vm._e(), _vm._v(" "), _c('br')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b16640e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/brokerCenter/NewApplication.vue
// module id = 1978
// module chunks = 5